// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"carousel-header_wrapper__3jn8w","category":"carousel-header_category__1C7c8","number":"carousel-header_number__3sUiP"};